<script setup>
import {ref, toRef} from "vue";
import {useLanguageStore, useLoadingStore} from "@/pinia";

const languageStore = useLanguageStore();
const loadingStore = useLoadingStore();

const props = defineProps(["isTransferModal"])
const emits = defineEmits(["set_isTransferModal", "transferVideos"]);
const items = [ {"title" : 'FTP', "value" : "ftp"} , {"title" : "SFTP", "value" : 'sftp'}]
const visible = ref(false);
const transferType = ref();
const path = ref();
const ip = ref();
const id = ref();
const pwd = ref();

const close = ()=>{
  transferType.value= null;
  path.value=null;
  ip.value=null;
  id.value=null;
  pwd.value=null;
  emits('set_isTransferModal', false);
}
const transfer = ()=>{
  let data ={
    "transferType" : transferType.value,
    "path" : path.value,
    "id" : id.value,
    "ip" : ip.value,
    "pwd" : pwd.value
  }
  emits("transferVideos", data)
  close();
}

</script>

<template>
  <v-dialog
      :model-value="isTransferModal"
      @update:modelValue="close"
      width="auto"
  >
    <v-card
        :title="languageStore.get('transmission')"
        :subtitle="languageStore.get('enterInfoToTransmit')"
        width="470"
    >
      <v-card-text>
        <v-select
            v-model="transferType"
            :items="items"
            :label="languageStore.get('transferMethod') + ' *'"
            density="compact"
            variant="outlined"
            hide-details="auto"
            class="mb-4"
        ></v-select>

        <v-text-field
            v-model="ip"
            label="IP 주소 *"
            density="compact"
            variant="outlined"
            hide-details="auto"
            class="mb-4"
        ></v-text-field>

        <v-text-field
            v-model="path"
            :label="languageStore.get('path') + ' *'"
            density="compact"
            variant="outlined"
            hide-details="auto"
            class="mb-4"
        ></v-text-field>

        <v-text-field
            v-model="id"
            label="ID *"
            variant="outlined"
            density="compact"
            hide-details="auto"
            class="mb-4"
        ></v-text-field>

        <v-text-field
            v-model="pwd"
            :label="languageStore.get('password') + ' *'"
            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
            :type="visible ? 'text' : 'password'"
            density="compact"
            variant="outlined"
            hide-details="auto"
            @click:append-inner="visible = !visible"
        ></v-text-field>
      </v-card-text>

      <v-card-actions class="modal-actions">
        <v-progress-circular
            v-show="loadingStore.isLoading"
            color="#052C65"
            indeterminate
        ></v-progress-circular>
        <v-spacer />
        <v-btn
            v-show="!loadingStore.isLoading"
            color="primary"
            variant="flat"
            @click="transfer"
        >{{ languageStore.get('transmission') }}</v-btn>
        <v-btn variant="outlined" @click="close">{{ languageStore.get('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
/* 모달 헤더 스타일 */
:deep(.v-card-item) {
  background-color: #1A3A5C !important;
  padding: 0 !important;
}

:deep(.v-card-title) {
  background-color: #1A3A5C !important;
  color: #FFFFFF !important;
  padding: 16px 24px 8px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
}

:deep(.v-card-subtitle) {
  padding: 0 24px 16px !important;
  background-color: #1A3A5C !important;
  color: rgba(255, 255, 255, 0.8) !important;
  opacity: 1 !important;
}

/* 모달 바디 - Vuetify 기본 padding 제거 */
:deep(.v-card-text) {
  padding: 24px !important;
}

/* 모달 액션 - Vuetify 기본 padding 제거 */
:deep(.v-card-actions.modal-actions) {
  padding: 16px 24px !important;
  border-top: 1px solid #DEE2E6;
  gap: 8px;
}

/* v-card-text 내 입력 필드 간격 */
.v-card-text :deep(.v-input) {
  margin-bottom: 16px;
}

.v-card-text :deep(.v-input:last-child) {
  margin-bottom: 0;
}
</style>